import { render, staticRenderFns } from "./genericSql.vue?vue&type=template&id=5b846254&"
import script from "./genericSql.vue?vue&type=script&lang=js&"
export * from "./genericSql.vue?vue&type=script&lang=js&"
import style0 from "./genericSql.vue?vue&type=style&index=0&id=5b846254&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports